export default __webpack_public_path__ + "assets/38f724f139f9bcb7d7339d7b35cd5f6e.mp4";